import {
  GET_CAR,
  SHOW_CAR,
  CREATE_CAR,
  EDIT_CAR,
  DELETE_CAR
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_CAR]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/cars",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_CAR]({ dispatch }, params) {
      let url = "/kanri/cars/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_CAR]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/cars",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_CAR]({ dispatch }, params) {
      let url = "/kanri/cars/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_CAR]({ dispatch }, params) {
      let url = "/kanri/cars/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
